import PersonIcon from '@mui/icons-material/Person';
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Avatar } from '@material-ui/core';
const style = {
 position: 'absolute' as 'absolute',
  top: '145px',
  left: '152px',
  transform: 'translate(-50%, -50%)',
  width: 250,
  bgcolor: 'background.paper',
  border: '0.1px solid gray',
  boxShadow: 8,
  p: 4,
  bborderRadius:"2" 
};
 function LogoutCmp() {
 const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
   return (
     <div style={{cursor:"pointer"}} >
        <PersonIcon onClick={handleOpen} style={{width:"67%",height:"67%",margin:'auto',marginTop:'10px',color:'blueviolet'}}/>
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
           <Avatar src='/images/girl.jpg'/> 
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Amdin
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
          </Typography>
          <Button> Sign up</Button>
          <Button> more</Button>
        </Box>
      </Modal>
     </div>
   )
 }
 
 export default LogoutCmp